import React from 'react';

/**
 * The handful of icons the ride receipt uses, drawn inline (like the rest of the
 * app) so the passenger app needs no icon library.
 *
 * Shapes are from Lucide (https://lucide.dev), ISC License:
 * Copyright (c) 2026 Lucide Icons and Contributors. Permission to use, copy,
 * modify, and/or distribute this software for any purpose with or without fee is
 * hereby granted, provided that this copyright notice and permission notice
 * appear in all copies.
 */
const SHAPES = {
  ArrowLeft: [['path',{d:'m12 19-7-7 7-7'}],['path',{d:'M19 12H5'}]],
  Banknote: [['rect',{width:'20',height:'12',x:'2',y:'6',rx:'2'}],['circle',{cx:'12',cy:'12',r:'2'}],['path',{d:'M6 12h.01M18 12h.01'}]],
  Check: [['path',{d:'M20 6 9 17l-5-5'}]],
  ChevronRight: [['path',{d:'m9 18 6-6-6-6'}]],
  Clock: [['circle',{cx:'12',cy:'12',r:'10'}],['path',{d:'M12 6v6l4 2'}]],
  Copy: [['rect',{width:'14',height:'14',x:'8',y:'8',rx:'2',ry:'2'}],['path',{d:'M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2'}]],
  HelpCircle: [['circle',{cx:'12',cy:'12',r:'10'}],['path',{d:'M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3'}],['path',{d:'M12 17h.01'}]],
  MapPin: [['path',{d:'M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0'}],['circle',{cx:'12',cy:'10',r:'3'}]],
  Share2: [['circle',{cx:'18',cy:'5',r:'3'}],['circle',{cx:'6',cy:'12',r:'3'}],['circle',{cx:'18',cy:'19',r:'3'}],['line',{x1:'8.59',x2:'15.42',y1:'13.51',y2:'17.49'}],['line',{x1:'15.41',x2:'8.59',y1:'6.51',y2:'10.49'}]],
  Star: [['path',{d:'M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z'}]],
  CarTaxiFront: [['path',{d:'M10 2h4'}],['path',{d:'m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8'}],['path',{d:'M7 14h.01'}],['path',{d:'M17 14h.01'}],['rect',{width:'18',height:'8',x:'3',y:'10',rx:'2'}],['path',{d:'M5 18v2'}],['path',{d:'M19 18v2'}]],
};

const makeIcon = (name) => {
  const Icon = ({ size = 24, strokeWidth = 2, fill = 'none', ...rest }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {SHAPES[name].map(([tag, attrs], i) => React.createElement(tag, { key: i, ...attrs }))}
    </svg>
  );
  Icon.displayName = name;
  return Icon;
};

export const ArrowLeft = makeIcon('ArrowLeft');
export const Banknote = makeIcon('Banknote');
export const CarTaxiFront = makeIcon('CarTaxiFront');
export const Check = makeIcon('Check');
export const ChevronRight = makeIcon('ChevronRight');
export const Clock = makeIcon('Clock');
export const Copy = makeIcon('Copy');
export const HelpCircle = makeIcon('HelpCircle');
export const MapPin = makeIcon('MapPin');
export const Share2 = makeIcon('Share2');
export const Star = makeIcon('Star');
